import routes from '@/modules/invoice/invoice-routes';
import store from '@/modules/invoice/invoice-store';

export default {
  routes,
  store,
};
